import { render, staticRenderFns } from "./Regolamento.vue?vue&type=template&id=63a07941&"
import script from "./Regolamento.vue?vue&type=script&lang=ts&"
export * from "./Regolamento.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63a07941')) {
      api.createRecord('63a07941', component.options)
    } else {
      api.reload('63a07941', component.options)
    }
    module.hot.accept("./Regolamento.vue?vue&type=template&id=63a07941&", function () {
      api.rerender('63a07941', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Regolamento.vue"
export default component.exports